import React from "react";
import Header from "../layouts/Header";

export default function HomePageManagement(){
    return (
        <React.Fragment>
            <Header />
        </React.Fragment>
    )
}